<!--助力分享-->
<!--仅仅完成简单的分享&助力功能-->
<!--需要绑定活动Id 以获取分享码-->
<template>
  <ModalCommon ref="ModalCommon" :title="config.title">
    <div class="wrap">
      <div class="content">
        <div class="sub-title">复制链接进行分享</div>
        <div class="link-wrap">
          <p class="bg-cv">{{ shareLink }}</p>
          <div class="line"></div>
          <div class="btn-share hv-highlight flex-shrink-0" @click="copy">复制</div>
        </div>
      </div>
    </div>
  </ModalCommon>
</template>

<script>
import ModalCommon from "@/components/BuilderComponents/_components/ModalCommon.vue";
import { copyContent } from "@/components/BuilderComponents/utils";
export default {
  name: 'VersionModalInviteTeam',
  components: {
    ModalCommon
  },
  props: {
    activityId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      shareLink: '',
      myCode: '',
      config: {
        title: '分享'
      }
    }
  },
  inject: {
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI() {
      return this.request ? this.request : window.$request
    }
  },
  async mounted() {
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.getShareCode)
      // 登出操作添加
      this.eventBus.on('signOut', this.getShareCode)
    }
  },
  methods: {
    async open(options) {
      if (!window.$checkLogin()) return
      this.config = Object.assign({
        title: '分享'
      }, options)
      await this.initLink()
      this.$refs.ModalCommon.open()
    },
    getShareCode(dailogText) {
      if (!window.$checkLogin()) return
      if (this.$route.query.code) {
        const { code } = this.$route.query
        this.$MainWrap.myAlert({
          str: dailogText,
          title: '提示',
          showCancel: '取消',
          sb: () => {
            this.requestAPI({
              url: '/v1/uni/official/team-join',
              method: 'get',
              params: {
                a_id: this.activityId,
                code
              }
            }).then(() => {
              this.$message.success('操作成功')
              this.$emit('joinSuccess')
              this.$MainWrap.init && this.$MainWrap.init()
              if (code) this.clearPath()
            }).catch(err => {
              console.error(err)
              this.$message.error(err.msg || '系统错误')
              if (code) this.clearPath()
            })
          },
          eb: () => {
          },
          fb: () => {
            if (code) this.clearPath()
          }
        })
      }
    },
    initLink() {
      const link = window.location.origin + window.location.pathname
      const { from, wdFrom } = this.$route.query
      const fromQuery = `${from ? '&from=' + from : ''}`
      let wdFromQuery = `${wdFrom ? '&wdFrom=' + wdFrom : ''}`
      if (wdFrom === 'website' || wdFrom === 'lenovo') {
        wdFromQuery = ''
      }
      this.shareLink = link + (link.indexOf('?') > -1 ? '&' : '?') + 'code=' + this.$MainWrap.homeInfo.team_code + wdFromQuery + fromQuery
    },
    copy() {
      copyContent(
        `${this.config.tipText} ${this.shareLink}`
      ).then(() => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      })
    },
    clearPath() {
      const query = JSON.parse(JSON.stringify(this.$route.query))
      delete query.code
      delete query.role_name
      this.$router.replace({
        path: window.location.pathname,
        query
      })
    }
  },
  beforeDestroy() {
    if (this.eventBus) {
      // console.log('> act1 取消登录监听')
      this.eventBus.off('loginSuccess', this.getShareCode)
      this.eventBus.off('signOut', this.getShareCode)
    }
  }
}
</script>

<style scoped lang="scss">
.wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  padding: 0 60px 100px;

  .sub-title {
    text-align: center;
    margin-bottom: 40px;
    font-size: 30px;
  }

  .link-wrap {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, .6);
    border-radius: 4px;

    p {
      flex: 1;
      height: 65px;
      line-height: 65px;
      padding: 0 20px;
      color: #fff;
      //background-image: url("../../../assets/images/fungus/link_bg.png");
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      letter-spacing: normal;
      font-size: 20px;
    }

    .line {
      width: 1px;
      height: 40px;
      background-color: #fff;
    }

    .btn-share {
      margin-left: 10px;
      width: 177px;
      font-size: 27px;
      height: 73px;
      line-height: 73px;
      text-align: center;
      color: #eee;

      &:hover {
        color: #fff;
      }
    }
  }
}
</style>
